export class ToastConfig {
  public icon?: string;
  public iconColour?: string;
  public assetPath?: string;

  constructor(public toastMessage: string, public timeVisibleInSeconds: number) {}
}
